import React from 'react';
import Icon from '../../../components/AppIcon';

const InventoryAlert = ({ 
  producto, 
  stockActual, 
  stockMinimo, 
  categoria,
  onClick 
}) => {
  const urgencyLevel = stockActual === 0 ? 'critical' : stockActual <= stockMinimo / 2 ? 'high' : 'medium';
  
  const urgencyConfig = {
    critical: {
      bgColor: 'bg-red-50',
      borderColor: 'border-red-200',
      iconColor: 'var(--color-error)',
      textColor: 'text-red-700',
      label: 'Sin stock'
    },
    high: {
      bgColor: 'bg-orange-50',
      borderColor: 'border-orange-200',
      iconColor: 'var(--color-warning)',
      textColor: 'text-orange-700',
      label: 'Crítico'
    },
    medium: {
      bgColor: 'bg-yellow-50',
      borderColor: 'border-yellow-200',
      iconColor: 'var(--color-warning)',
      textColor: 'text-yellow-700',
      label: 'Bajo'
    }
  };

  const config = urgencyConfig?.[urgencyLevel];

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const handleKeyDown = (e) => {
    if (e?.key === 'Enter' || e?.key === ' ') {
      e?.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={`${config?.bgColor} rounded-lg p-3 md:p-4 border ${config?.borderColor} transition-smooth cursor-pointer hover:shadow-elevation-1`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0">
          <Icon name="AlertTriangle" size={20} color={config?.iconColor} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-1">
            <p className="text-sm font-semibold text-foreground truncate">
              {producto}
            </p>
            <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${config?.textColor} bg-white/50 whitespace-nowrap ml-2`}>
              {config?.label}
            </span>
          </div>
          <p className="text-xs text-muted-foreground mb-2">
            {categoria}
          </p>
          <div className="flex items-center justify-between text-xs">
            <span className="text-muted-foreground">
              Stock actual: <span className={`font-semibold ${config?.textColor}`}>{stockActual}</span>
            </span>
            <span className="text-muted-foreground">
              Mínimo: {stockMinimo}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InventoryAlert;